@if(showEmojiPicker) {
<div class="emoji-picker-container">
  <emoji-mart (emojiClick)="addEmoji($event)"></emoji-mart>
</div>
}
